import * as ActionTypes from '../constants';

export default function(state={}, action) {
    
    switch(action.type) {
        case(ActionTypes.REQUEST_LOGOUT):
            return {
                ...state,
                loading: true,
                error: false,
                successMsg: null,
                errInfo: null
            }
        case(ActionTypes.RECEIVED_LOGOUT):
            return {
                ...state,
                loading: false,
                successMsg: action.msg,
                error: false,
                errInfo: null
            }
        case(ActionTypes.ERROR_LOGOUT):
            return {
                ...state,
                loading: false,
                successMsg: null,
                error: true,
                errInfo: action.msg
            }
        case(ActionTypes.CLEAR_LOGOUT_ALL_DATA):
            return {}
        default: return state

    }
}

